import userPermissionReportComponent from './user_permission_report.component';
import userPermissionReportAll from './all';

let userPermissionReportModule = angular.module('userPermissionReport', [
    userPermissionReportAll
])

    .component('userPermissionReport', userPermissionReportComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $stateProvider
            .state('user_permission_report.all', {
                url: '/all',
                component: 'userPermissionReportAll',
                data: {
                    requireACL: 'tnt_control_user_permission_report.view'
                }
            })
    })

    .name;

export default userPermissionReportModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/user_permission_report/index.js